module.exports = {
  // CALLBACK_URL_COUPON :`${window.location.origin}/#/order-success`,
  // BASE_URL:'https://adserver.mall91.com/rest/campaign',
  BASE_API_URL: 'https://teenpatti.money91.com',
  BASE_URL2 :'https://billsbe.payboard.in/api/v1/',
  BASE_URL: "https://3897a83a08df.ngrok.io/DBCampaignService/rest",
  FILE_UPLOAD_URL: "https://media.getzyk.com/uploadMediaFile/8",
  CALLBACK_URL_COUPON :`${window.location.origin}/#/order-status`,
  Payboard: 'http://tracking.payboard.in/PayBoard/rest/user',
  GetJWT: "https://3897a83a08df.ngrok.io/DBCampaignService/rest/user/get-jwt-token",
};